






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.commit("setGauthCredentials", context.root.$route.query.credentials);
      context.root.$router.push(context.root.$store.state.gauthRedirectPath).catch(err => {});
    });

    return {
      ...toRefs(state),
    }
  }
})
